<template>
  <div>
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>
      <el-breadcrumb-item class="home" :to="{ path: '/' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item class="zpgg">{{ navname }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <Process></Process>
      <!-- 右边内容 -->
      <div class="exam_box" v-if="list.length > 0">
        <el-col :span="18">
          <div class="tab">
            <ul class="tab_top">
              <li>招聘岗位</li>
              <li>开始时间</li>
              <li>结束时间</li>
            </ul>
            <ul class="tab_btm">
              <li
                :class="[
                  'tab_btm_li',
                  { is_show_red_words: info.is_show_red_words == 1 },
                ]"
                v-for="(info, i) in list"
                :key="i"
              >
                <div
                  class="tab_btm_li_box"
                  @click="signup(info.id, info.is_sign_up)"
                >
                  <div :title="info.name">{{ info.name }}</div>
                  <div>{{ info.start_time }}</div>
                  <div>{{ info.end_time }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div :class="['block', { hide: isPageHide }]">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :currentPage="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-col>
      </div>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      isPageHide: 0,
      navid: 0,
      navname: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query = this.$route.query;
    this.navid = query.navid;
    this.navname = query.name;
    this.getList(1);
  },
  watch: {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList(val);
    },
    getList(pageid) {
      let _this = this;
      var navid = _this.navid;
      _this
        .request("/api/index/list", { nav_id: navid, page: pageid }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            let list = res.data.data.exam_list.data;
            for (let i = 0; i < list.length; i++) {
              list[i]["start_time"] = list[i]["start_time"].substring(0, 10);
              list[i]["end_time"] = list[i]["end_time"].substring(0, 10);
            }
            _this.list = list;
            _this.currentPage = res.data.data.exam_list.current_page;
            _this.total = res.data.data.exam_list.total;
            _this.pageSize = res.data.data.exam_list.per_page;
            if (res.data.data.exam_list.data.length == 0) {
              _this.isPageHide = 1;
            }
          }
        });
    },
    signup(id, is_sign_up) {
      if (this.isLogin() === false) {
        return;
      }
      if (is_sign_up == 0) {
        this.$router.push("/enroll?post_id=" + id);
      }
      if (is_sign_up == 1) {
        this.$router.push("/step?post_id=" + id);
      }
    },
  },
  components: {
    Process,
    Head,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.hide {
  display: none;
}
.exam_box {
  // table {
  //   margin: 0 auto;

  //   border-collapse: collapse;
  //   tr {
  //     font-size: 0.33rem;
  //     border-bottom: #5b9bd5 2px solid;
  //     text-align: center;
  //     th {
  //       background-color: #5b9bd5;
  //       border: none;
  //       padding: 0.15rem 0;
  //       color: #fff;
  //     }
  //     td {
  //       padding: 0.15rem 0;
  //       border: 1px solid rgb(63, 63, 63);
  //     }
  //     .item_href:hover {
  //       cursor: pointer;
  //       color: #5b9bd5;
  //     }
  //   }
  // }
  .tab {
    margin-left: 0.7rem;
    .tab_top {
      display: flex;
      padding-right: 0.2rem;
      li {
        font-size: 0.29rem;
        color: #5a5959;
        text-align: center;
        padding: 0.37rem 0;
      }
      li:nth-of-type(1) {
        flex: 3;
      }
      li:nth-of-type(2) {
        flex: 1;
      }
      li:nth-of-type(3) {
        flex: 1;
      }
    }
    .tab_btm {
      .tab_btm_li {
        list-style: disc;
        cursor: pointer;
        .tab_btm_li_box {
          display: flex;
          div {
            font-size: 0.29rem;
            color: #2e2e2e;
            padding: 0.1rem 0.16rem;
            text-align: center;
          }
          div:nth-of-type(1) {
            flex: 3;
            text-align: center;
            overflow: hidden;

            text-overflow: ellipsis;

            white-space: nowrap;
          }
          div:nth-of-type(2) {
            flex: 1;
          }
          div:nth-of-type(3) {
            flex: 1;
          }
        }
      }
      .is_show_red_words {
        color: red;
        .tab_btm_li_box {
          div {
            color: red;
          }
        }
      }
    }
  }
  .block {
    text-align: center;
    .el-pagination {
      margin-top: 1rem;
      button {
        i {
          width: 0.33rem;
        }
      }
      .el-pager {
        li {
          font-size: 0.33rem;
        }
      }
    }
  }
}
</style>
